module.exports = __webpack_public_path__ + "static/media/eco.2b73f75e.png";